module.exports = __webpack_public_path__ + "static/media/start-play.33d33134.svg";